import Lookup from 'src/componentes/select-async';
import ApresentacaoList from 'src/paginas/apresentacao';

const ApresentacaoLookup = (props) => {
  return (
    <Lookup
      showSearch
      labelKey="nome"
      valueKey="id"
      url="/ApresentacaoLookup"
      clearable={false}
      searchComponent={ApresentacaoList}
      {...props}
    />
  );
};

export default ApresentacaoLookup;
